// extracted by mini-css-extract-plugin
export default {"newgroup":"style_newgroup__PTrz8"};